// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"35a37a1b","213":"2b9e29b4","239":"afe6811f","455":"2800641b","488":"abb754c0","684":"c189ca4f"}[chunkId] + ".chunk.js";
};